__turbopack_context__.v({
  "aboutbox1": "tnpsc-admissions-module__KSxb6q__aboutbox1",
  "aboutheading1": "tnpsc-admissions-module__KSxb6q__aboutheading1",
  "aboutheading2": "tnpsc-admissions-module__KSxb6q__aboutheading2",
  "aboutnumber": "tnpsc-admissions-module__KSxb6q__aboutnumber",
  "aboutparagraph1": "tnpsc-admissions-module__KSxb6q__aboutparagraph1",
  "acheivername": "tnpsc-admissions-module__KSxb6q__acheivername",
  "acheivernames": "tnpsc-admissions-module__KSxb6q__acheivernames",
  "acheivernamespecial": "tnpsc-admissions-module__KSxb6q__acheivernamespecial",
  "acheiverrank": "tnpsc-admissions-module__KSxb6q__acheiverrank",
  "acheiverrank1": "tnpsc-admissions-module__KSxb6q__acheiverrank1",
  "acheiverranks": "tnpsc-admissions-module__KSxb6q__acheiverranks",
  "acheiverranks2": "tnpsc-admissions-module__KSxb6q__acheiverranks2",
  "achiverbadge": "tnpsc-admissions-module__KSxb6q__achiverbadge",
  "active": "tnpsc-admissions-module__KSxb6q__active",
  "admincontent": "tnpsc-admissions-module__KSxb6q__admincontent",
  "admission": "tnpsc-admissions-module__KSxb6q__admission",
  "avatar": "tnpsc-admissions-module__KSxb6q__avatar",
  "badge": "tnpsc-admissions-module__KSxb6q__badge",
  "bangmainTitle": "tnpsc-admissions-module__KSxb6q__bangmainTitle",
  "bestbg": "tnpsc-admissions-module__KSxb6q__bestbg",
  "bestbg1": "tnpsc-admissions-module__KSxb6q__bestbg1",
  "blinkGlow": "tnpsc-admissions-module__KSxb6q__blinkGlow",
  "branchBtn": "tnpsc-admissions-module__KSxb6q__branchBtn",
  "branchBtnnew": "tnpsc-admissions-module__KSxb6q__branchBtnnew",
  "cardBox": "tnpsc-admissions-module__KSxb6q__cardBox",
  "cardSub": "tnpsc-admissions-module__KSxb6q__cardSub",
  "cardTop": "tnpsc-admissions-module__KSxb6q__cardTop",
  "carouselImg": "tnpsc-admissions-module__KSxb6q__carouselImg",
  "carouselWrapper": "tnpsc-admissions-module__KSxb6q__carouselWrapper",
  "circleGlow": "tnpsc-admissions-module__KSxb6q__circleGlow",
  "colCenter": "tnpsc-admissions-module__KSxb6q__colCenter",
  "colDate": "tnpsc-admissions-module__KSxb6q__colDate",
  "colFee": "tnpsc-admissions-module__KSxb6q__colFee",
  "colInfo": "tnpsc-admissions-module__KSxb6q__colInfo",
  "contactheader": "tnpsc-admissions-module__KSxb6q__contactheader",
  "contenttitles": "tnpsc-admissions-module__KSxb6q__contenttitles",
  "courseBtn": "tnpsc-admissions-module__KSxb6q__courseBtn",
  "coursesimg": "tnpsc-admissions-module__KSxb6q__coursesimg",
  "democlass": "tnpsc-admissions-module__KSxb6q__democlass",
  "description": "tnpsc-admissions-module__KSxb6q__description",
  "dot": "tnpsc-admissions-module__KSxb6q__dot",
  "dot1": "tnpsc-admissions-module__KSxb6q__dot1",
  "fadeUp": "tnpsc-admissions-module__KSxb6q__fadeUp",
  "featureCard": "tnpsc-admissions-module__KSxb6q__featureCard",
  "featureGrid": "tnpsc-admissions-module__KSxb6q__featureGrid",
  "featureSection": "tnpsc-admissions-module__KSxb6q__featureSection",
  "form-control": "tnpsc-admissions-module__KSxb6q__form-control",
  "heroCard": "tnpsc-admissions-module__KSxb6q__heroCard",
  "highlightCard": "tnpsc-admissions-module__KSxb6q__highlightCard",
  "highlightbtn": "tnpsc-admissions-module__KSxb6q__highlightbtn",
  "icon": "tnpsc-admissions-module__KSxb6q__icon",
  "imageBox": "tnpsc-admissions-module__KSxb6q__imageBox",
  "imageWrapper": "tnpsc-admissions-module__KSxb6q__imageWrapper",
  "imagee": "tnpsc-admissions-module__KSxb6q__imagee",
  "infoLabel": "tnpsc-admissions-module__KSxb6q__infoLabel",
  "infoRow": "tnpsc-admissions-module__KSxb6q__infoRow",
  "infoValue": "tnpsc-admissions-module__KSxb6q__infoValue",
  "inlinetabs": "tnpsc-admissions-module__KSxb6q__inlinetabs",
  "innerBox": "tnpsc-admissions-module__KSxb6q__innerBox",
  "innerBox1": "tnpsc-admissions-module__KSxb6q__innerBox1",
  "innerTitle": "tnpsc-admissions-module__KSxb6q__innerTitle",
  "mainText": "tnpsc-admissions-module__KSxb6q__mainText",
  "mainTitle": "tnpsc-admissions-module__KSxb6q__mainTitle",
  "morelink": "tnpsc-admissions-module__KSxb6q__morelink",
  "nav-item": "tnpsc-admissions-module__KSxb6q__nav-item",
  "nav-link": "tnpsc-admissions-module__KSxb6q__nav-link",
  "nav-pills": "tnpsc-admissions-module__KSxb6q__nav-pills",
  "nav-tabs": "tnpsc-admissions-module__KSxb6q__nav-tabs",
  "newcardBox": "tnpsc-admissions-module__KSxb6q__newcardBox",
  "newcardSub": "tnpsc-admissions-module__KSxb6q__newcardSub",
  "newcardSub1": "tnpsc-admissions-module__KSxb6q__newcardSub1",
  "newsectiontitle": "tnpsc-admissions-module__KSxb6q__newsectiontitle",
  "normalbluebutton": "tnpsc-admissions-module__KSxb6q__normalbluebutton",
  "normalbutton": "tnpsc-admissions-module__KSxb6q__normalbutton",
  "normalbutton1": "tnpsc-admissions-module__KSxb6q__normalbutton1",
  "normalbutton2": "tnpsc-admissions-module__KSxb6q__normalbutton2",
  "numberbold": "tnpsc-admissions-module__KSxb6q__numberbold",
  "pagegspcm": "tnpsc-admissions-module__KSxb6q__pagegspcm",
  "pagemaintitle": "tnpsc-admissions-module__KSxb6q__pagemaintitle",
  "pagemaintitles": "tnpsc-admissions-module__KSxb6q__pagemaintitles",
  "paybill": "tnpsc-admissions-module__KSxb6q__paybill",
  "paybutton": "tnpsc-admissions-module__KSxb6q__paybutton",
  "pcmbatch": "tnpsc-admissions-module__KSxb6q__pcmbatch",
  "premiumCard": "tnpsc-admissions-module__KSxb6q__premiumCard",
  "priceBox": "tnpsc-admissions-module__KSxb6q__priceBox",
  "primaryBtn": "tnpsc-admissions-module__KSxb6q__primaryBtn",
  "redStrip": "tnpsc-admissions-module__KSxb6q__redStrip",
  "redunderline": "tnpsc-admissions-module__KSxb6q__redunderline",
  "redunderlinealink": "tnpsc-admissions-module__KSxb6q__redunderlinealink",
  "ribbon": "tnpsc-admissions-module__KSxb6q__ribbon",
  "rotateGlow": "tnpsc-admissions-module__KSxb6q__rotateGlow",
  "scheduleHeader": "tnpsc-admissions-module__KSxb6q__scheduleHeader",
  "scheduleItem": "tnpsc-admissions-module__KSxb6q__scheduleItem",
  "scheduleSection": "tnpsc-admissions-module__KSxb6q__scheduleSection",
  "scrollcontent": "tnpsc-admissions-module__KSxb6q__scrollcontent",
  "scrolldiv": "tnpsc-admissions-module__KSxb6q__scrolldiv",
  "scrollparent": "tnpsc-admissions-module__KSxb6q__scrollparent",
  "sectionsubtitle": "tnpsc-admissions-module__KSxb6q__sectionsubtitle",
  "sectiontitle": "tnpsc-admissions-module__KSxb6q__sectiontitle",
  "show": "tnpsc-admissions-module__KSxb6q__show",
  "siaacheiverrank": "tnpsc-admissions-module__KSxb6q__siaacheiverrank",
  "siaacheiverrank2": "tnpsc-admissions-module__KSxb6q__siaacheiverrank2",
  "siahead": "tnpsc-admissions-module__KSxb6q__siahead",
  "star": "tnpsc-admissions-module__KSxb6q__star",
  "startegy": "tnpsc-admissions-module__KSxb6q__startegy",
  "startegy1": "tnpsc-admissions-module__KSxb6q__startegy1",
  "statCircle": "tnpsc-admissions-module__KSxb6q__statCircle",
  "statsRow": "tnpsc-admissions-module__KSxb6q__statsRow",
  "subText": "tnpsc-admissions-module__KSxb6q__subText",
  "tabactive": "tnpsc-admissions-module__KSxb6q__tabactive",
  "tableheading": "tnpsc-admissions-module__KSxb6q__tableheading",
  "tablepara": "tnpsc-admissions-module__KSxb6q__tablepara",
  "tablescroll": "tnpsc-admissions-module__KSxb6q__tablescroll",
  "tablinks": "tnpsc-admissions-module__KSxb6q__tablinks",
  "tablinks1": "tnpsc-admissions-module__KSxb6q__tablinks1",
  "tabscrollclass": "tnpsc-admissions-module__KSxb6q__tabscrollclass",
  "tabsection": "tnpsc-admissions-module__KSxb6q__tabsection",
  "title": "tnpsc-admissions-module__KSxb6q__title",
  "titles": "tnpsc-admissions-module__KSxb6q__titles",
  "toppersupsc": "tnpsc-admissions-module__KSxb6q__toppersupsc",
  "toptopheader": "tnpsc-admissions-module__KSxb6q__toptopheader",
  "ulclass": "tnpsc-admissions-module__KSxb6q__ulclass",
  "ulclass1": "tnpsc-admissions-module__KSxb6q__ulclass1",
  "ulclass2": "tnpsc-admissions-module__KSxb6q__ulclass2",
  "ulliclass": "tnpsc-admissions-module__KSxb6q__ulliclass",
  "ulliclass1": "tnpsc-admissions-module__KSxb6q__ulliclass1",
  "ullispan": "tnpsc-admissions-module__KSxb6q__ullispan",
  "ullispan1": "tnpsc-admissions-module__KSxb6q__ullispan1",
  "ullispan2": "tnpsc-admissions-module__KSxb6q__ullispan2",
  "whatsnewkeyanimation": "tnpsc-admissions-module__KSxb6q__whatsnewkeyanimation",
  "widthmax": "tnpsc-admissions-module__KSxb6q__widthmax",
});
